import { themeOrange } from "../theme";

const insetHeight = 20;

export const styles = {
  headerWrapper: {
    padding: "0 8px",
    marginLeft: 24,
    marginRight: 24,
    borderRadius: "0px 0px 24px 24px",
    background: "linear-gradient(90deg, #00131B 0%, #144252 45%, #59A9BC 75%, #76D1E4 100%)",
    height: 51,
  },
  inset: {
    width: "100%",
    position: "relative" as const,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logo: {
    cursor: "pointer",
  },
  logoImage: {
    height: insetHeight,
    maxHeight: insetHeight,
    padding: 0,
  },
  link: {
    paddingLeft: 24,
    paddingRight: 24,
    color: "white",
    fontSize: 20,
    fontWeight: "bold",
    cursor: "pointer",
    transition: 0.2,
  },
  backWrapper: {
    position: "absolute" as const,
    left: 0,
    display: "flex",
    alignItems: "center",
  },
  backIcon: {
    marginRight: 2,
    fontSize: 24,
    transition: ".2s",
  },
  barsIcon: {
    position: "absolute" as const,
    left: 0,
    color: "#777",
    fontSize: 28,
    transition: ".2s",
  },
  appLogo: {
    maxHeight: insetHeight,
    paddingTop: 10,
    paddingBottom: 10,
    marginRight: 10,
  },
  settingsModal: {
    position: "absolute" as const,
    top: "6.5%",
    right: 40,
    width: 200,
    background: "#FFF",
    zIndex: 5,
    borderRadius: 28,
    padding: 22,
    color: "#0076BA",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)"
  },
  companyModal: {
    position: "absolute" as const,
    top: "6.5%",
    right: 220,
    width: 202,
    textAlign: "left" as const,
    zIndex: 5,
    borderRadius: 28,
    background: "#FFF",
    padding: 16,
    color: "#0076BA",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)"
  },
  companyOption: {
    zIndex: 20,
    fontSize: 16,
    textAlign: "left" as const,
    fontWeight: "400",
    color: "#0076BA",
    padding: "10px 14px",
    cursor: "pointer",
  },
  settingOption: {
    zIndex: 20,
    fontSize: 16,
    fontWeight: "400",
    color: "#0076BA",
    padding: "10px 14px",
    cursor: "pointer",
  },
  settingOptionDisabled: {
    zIndex: 20,
    fontSize: 16,
    fontWeight: "400",
    color: "gray",
    padding: "10px 14px",
    cursor: "not-allowed",
  },
  settingOverlay: {
    height: "100vh",
    width: "100vw",
    position: "absolute" as const,
    left: 0,
    top: 0,
  },
  firstName: {
    fontSize: 16,
    marginLeft: 12,
  },
  iconCircle: {
    background: "#0076ba",
    padding: 4,
    borderRadius: 1000,
  },
  adminLabel: {
    marginLeft: 8,
    background: themeOrange,
    color: "white",
    fontSize: 14,
    fontWeight: "bold",
    padding: "0px 4px",
    borderRadius: 4,
  },
  companyName: {
    justifyContent: "space-between" as const,
    display: "flex" as const,
    color:" var(--White-White, #FFF)",
    textAlign: "right" as const,

    /* Body Medium/Regular */
    fontFamily: "Inter",
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 400,
  },
  notificationHolder: {
    display: "flex",
    width: 40,
    height: 40,
    padding: 8,
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: 200,
    background: "#090E34",
    marginLeft: 8,
  },
};
